import { Component } from '@angular/core';

@Component({
    selector: 'app-dashboard-data-analysis',
    templateUrl: './dashboard-data-analysis.component.html',
    styleUrls: ['./dashboard-data-analysis.component.scss'],
    standalone: false
})
export class DashboardDataAnalysisComponent {

}
